import type React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CommentActionButtonProps {
  commentText: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isCommentDisabled: boolean;
  isCommentActive: boolean;
  size?: "md" | "sm";
}

export const CommentActionButton: React.FC<CommentActionButtonProps> = ({
  commentText,
  onClick,
  isCommentDisabled,
  isCommentActive,
  size = "md",
}) => {
  const buttonSizeClass = size === "sm" ? "h-6 px-1 text-xs" : "";
  const commentIconSizeClass = size === "sm" ? "h-3 w-3" : "h-4 w-4";

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      disabled={isCommentDisabled}
      className={cn(
        buttonSizeClass,
        "gap-x-1 text-gray-500",
        isCommentActive && "bg-primary/10 text-primary ring-1 ring-primary/30",
      )}
      size={size === "sm" ? "sm" : "default"}
    >
      <img
        src="/return.svg"
        alt="comment"
        className={cn(commentIconSizeClass, "opacity-60")}
      />
      <span
        className={cn(
          "ml-0",
          size === "sm" ? "font-sub text-xs text-gray-500" : "text-gray-500",
        )}
      >
        {commentText}
      </span>
    </Button>
  );
};
